import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Inbox, Home, Building2, Wrench, Images, BarChart3, KeyRound, ExternalLink } from "lucide-react";
import { useContent } from "../context/ContentContext";
import QuotesPanel from "./admin/QuotesPanel";
import HomeEditor from "./admin/HomeEditor";
import CompanyEditor from "./admin/CompanyEditor";
import ServicesEditor from "./admin/ServicesEditor";
import GalleryEditor from "./admin/GalleryEditor";
import StatsEditor from "./admin/StatsEditor";
import AccountEditor from "./admin/AccountEditor";

const TABS = [
  { id: "quotes", label: "Preventivi", icon: Inbox, Comp: QuotesPanel },
  { id: "home", label: "Home", icon: Home, Comp: HomeEditor },
  { id: "company", label: "Azienda", icon: Building2, Comp: CompanyEditor },
  { id: "services", label: "Servizi", icon: Wrench, Comp: ServicesEditor },
  { id: "gallery", label: "Galleria", icon: Images, Comp: GalleryEditor },
  { id: "stats", label: "Statistiche", icon: BarChart3, Comp: StatsEditor },
  { id: "account", label: "Password", icon: KeyRound, Comp: AccountEditor },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { content } = useContent();
  const COMPANY = content.company;
  const [tab, setTab] = useState("quotes");

  const token = localStorage.getItem("ci_token");
  const user = JSON.parse(localStorage.getItem("ci_user") || "null");

  const logout = useCallback(() => {
    localStorage.removeItem("ci_token");
    localStorage.removeItem("ci_user");
    navigate("/admin/login");
  }, [navigate]);

  useEffect(() => {
    if (!token) navigate("/admin/login");
  }, [token, navigate]);

  if (!token) return null;

  const Active = TABS.find((t) => t.id === tab).Comp;

  return (
    <div className="min-h-screen bg-paper">
      <header className="bg-navy-deep text-paper grain relative">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between relative z-10">
          <div className="flex items-center gap-4">
            <img src={COMPANY.logo} alt="logo" className="h-12 w-auto object-contain bg-paper/95 p-1.5" />
            <div>
              <p className="eyebrow">Area amministratore</p>
              <p className="text-paper/60 text-sm">{user?.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href="/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-paper/20 px-4 py-2.5 text-xs uppercase tracking-[0.18em] hover:border-gold hover:text-gold transition-colors">
              <ExternalLink size={14} /> Vedi il sito
            </a>
            <button onClick={logout} className="inline-flex items-center gap-2 bg-gold text-navy px-4 py-2.5 text-xs uppercase tracking-[0.18em] hover:bg-gold-soft transition-colors">
              <LogOut size={14} /> Esci
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <nav className="flex gap-1 overflow-x-auto -mb-px">
            {TABS.map((t) => {
              const Icon = t.icon;
              const active = t.id === tab;
              return (
                <button
                  key={t.id}
                  onClick={() => setTab(t.id)}
                  className={`inline-flex items-center gap-2 px-4 py-3 text-xs uppercase tracking-[0.15em] whitespace-nowrap border-b-2 transition-colors ${
                    active ? "border-gold text-gold" : "border-transparent text-paper/50 hover:text-paper"
                  }`}
                >
                  <Icon size={15} /> {t.label}
                </button>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <Active logout={logout} />
      </main>
    </div>
  );
}
